import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

export async function getOrganizationGivingAccountLink(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/giving-account/account-link`;

  const response = await api.executeGetRequest<ObjectResponse<{ url: string }>>(url);

  return response.data;
}
